// extracted by mini-css-extract-plugin
export default {"buttonPairList":"ButtonPairList_buttonPairList__ggYDs","buttonPair":"ButtonPairList_buttonPair__3zhU8"};